/**
 * Upload engine settings. The first two must equal the backend's
 * `UploadCoordinator.CHUNK_SIZE` and `THRESHOLD`: Uppy splits a file into parts
 * before `initialize` answers, so the part size cannot be learned from the server.
 */
export const CHUNK_SIZE = 10 * 1024 * 1024;
/** Media above this size goes multipart; media this size or smaller goes as one signed PUT. Other resources are always multipart. */
export const MULTIPART_THRESHOLD = 5 * 1024 * 1024;

/** Waits before each retry of a part or its URL: about 50 s of unreported dropout before a file fails. */
export const RETRY_DELAYS = [0, 1000, 3000, 5000, 10000, 30000];
/** Parallel requests, shared by every file in one Uppy instance. */
export const CONCURRENCY = 6;

/** How long an interrupted upload can be resumed. The backend drops a session after 24 h without a request. */
export const RESUME_TTL_MS = 24 * 60 * 60 * 1000;

/** initialize, sign-parts, list-parts and abort. Initialize can be slow for a file with thousands of parts. */
export const CONTROL_TIMEOUT_MS = 2 * 60 * 1000;
/** S3 assembles every part before `complete` answers. */
export const COMPLETE_TIMEOUT_MS = 10 * 60 * 1000;
